import claraImage from '../../assets/img/home/home-v2/home-section-clara.jpg'
import joaoImage from '../../assets/img/home/home-v2/home-section-joao.jpg'
import marcosImage from '../../assets/img/home/home-v2/home-section-marcos.jpg'

export interface Testimonial {
  name: string
  age: number
  quote: string
  image: string
}

export const testimonialsData: Testimonial[] = [
  {
    name: 'Clara Azevedo',
    age: 35,
    quote:
      'Fiquei impressionada com a rapidez do agendamento. Consegui marcar minha consulta em poucos minutos e me senti acolhida em todas as etapas.',
    image: claraImage
  },
  {
    name: 'João Carvalho',
    age: 41,
    quote:
      'O sistema de consultas é bem intuitivo. Conversei com uma médica que foi super profissional. Recomendo para quem busca uma orientação séria.',
    image: joaoImage
  },
  {
    name: 'Marcos Nogueira',
    age: 47,
    quote:
      'Desde o início, percebi o cuidado da Cannect com os clientes. O médico que me atendeu quebrou todos os preconceitos que eu tinha sobre a cannabis medicinal.',
    image: marcosImage
  }
]
